const spellsLVL4 = [
  {
    index: 'blight',
    name: 'Blight',
    url: '/api/spells/blight',
    shortdesc:
      'On a failed Con save (half on success) target takes 8d8 necrotic damage',
    desc: [
      'Necromantic energy washes over a creature of your choice that you can see within range, draining moisture and vitality from it. The target must make a constitution saving throw. The target takes 8d8 necrotic damage on a failed save, or half as much damage on a successful one. The spell has no effect on undead or constructs.',
      'If you target a plant creature or a magical plant, it makes the saving throw with disadvantage, and the spell deals maximum damage to it.',
      "If you target a nonmagical plant that isn't a creature, such as a tree or shrub, it doesn't make a saving throw; it simply withers and dies.",
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 5th level of higher, the damage increases by 1d8 for each slot level above 4th.',
    ],
    range: '30 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'confusion',
    name: 'Confusion',
    url: '/api/spells/confusion',
    shortdesc:
      'On a failed Wis save in a 10 ft sphere, affected creatures become confused.',
    desc: [
      'This spell assails and distorts the minds of creatures, generating illusions and causing uncontrolled actions. Each creature in a sphere of 10-foot-radius centered on a point chosen in the range of the spell must make a wisdom saving throw otherwise it will be affected by the spell.',
      'An affected target can react and it must start at the beginning of 1d10 each of his game rounds to determine its behavior for that round.',
      'At the end of each turn, an affected creature can make a saving throw of Wisdom. If successful, the effect of the spell ends for this target.',
    ],
    higher_level: [
      'When you cast this spell using a level spell slot 5 or more, the radius of the sphere increases by 5 feet for each level of higher spell slot to 4.',
    ],
    range: '90 feet',
    components: ['V', 'S', 'M'],
    material: 'Three walnut shells.',
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 4,
    dc: {
      dc_type: {
        index: 'wis',
        name: 'WIS',
        url: '/api/ability-scores/wis',
      },
      dc_success: 'none',
    },
    area_of_effect: {
      type: 'sphere',
      size: 10,
    },
  },
  {
    index: 'conjure-minor-elementals',
    name: 'Conjure Minor Elementals',
    url: '/api/spells/conjure-minor-elementals',
    shortdesc: 'Summons either one of the options.',
    desc: [
      'You summon elementals that appear in unoccupied spaces that you can see within range. You choose one the following options for what appears:',
      '- One elemental of challenge rating 2 or lower',
      '- Two elementals of challenge rating 1 or lower',
      '- Four elementals of challenge rating 1/2 or lower',
      '- Eight elementals of challenge rating 1/4 or lower.',
      'An elemental summoned by this spell disappears when it drops to 0 hit points or when the spell ends.',
      "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which has its own turns. They obey any verbal commands that you issue to them (no action required by you). If you don't issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions.",
      "The DM has the creatures' statistics.",
    ],
    higher_level: [
      'When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 6th-level slot and three times as many with an 8th-level slot.',
    ],
    range: '90 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 minute',
    level: 4,
  },
  {
    index: 'conjure-woodland-beings',
    name: 'Conjure Woodland Beings',
    url: '/api/spells/conjure-woodland-beings',
    shortdesc: 'You summon fey creatures that can be one of the following:',
    desc: [
      'You summon fey creatures that appear in unoccupied spaces that you can see within range. Choose one of the following options for what appears:',
      'One fey creature of challenge rating 2 or lower',
      'Two fey creatures of challenge rating 1 or lower',
      'Four fey creatures of challenge rating 1/2 or lower',
      'Eight fey creatures of challenge rating 1/4 or lower',
      'A summoned creature disappears when it drops to 0 hit points or when the spell ends.',
      "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which have their own turns. They obey any verbal commands that you issue to them (no action required by you). If you don't issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions.",
      "The DM has the creatures' statistics.",
    ],
    higher_level: [
      'When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 6th-level slot and three times as many with an 8th-level slot.',
    ],
    range: '60 feet',
    components: ['V', 'S', 'M'],
    material: 'One holly berry per creature summoned.',
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'control-water',
    name: 'Control Water',
    url: '/api/spells/control-water',
    shortdesc: 'You control any freestanding water inside an area you choose',
    desc: [
      'Until the spell ends, you control any freestanding water inside an area you choose that is a cube up to 100 feet on a side. You can choose from any of the following effects when you cast this spell. As an action on your turn, you can repeat the same effect or choose a different one.',
      'Flood.',
      'You cause the water level of all standing water in the area to rise by as much as 20 feet. If the area includes a shore, the flooding water spills over onto dry land.',
      "instead create a 20-foot tall wave that travels from one side of the area to the other and then crashes down. Any Huge or smaller vehicles in the wave's path are carried with it to the other side. Any Huge or smaller vehicles struck by the wave have a 25 percent chance of capsizing.",
      'The water level remains elevated until the spell ends or you choose a different effect. If this effect produced a wave, the wave repeats on the start of your next turn while the flood effect lasts.',
      'Part Water.',
      "You cause water in the area to move apart and create a trench. The trench extends across the spell's area, and the separated water forms a wall to either side. The trench remains until the spell ends or you choose a different effect. The water then slowly fills in the trench over the course of the next round until the normal water level is restored.",
      'Redirect Flow.',
      "You cause flowing water in the area to move in a direction you choose, even if the water has to flow over obstacles, up walls, or in other unlikely directions. The water in the area moves as you direct it, but once it moves beyond the spell's area, it resumes its flow based on the terrain conditions. The water continues to move in the direction you chose until the spell ends or you choose a different effect.",
      'Whirlpool.',
      'This effect requires a body of water at least 50 feet square and 25 feet deep. You cause a whirlpool to form in the center of the area. The whirlpool forms a vortex that is 5 feet wide at the base, up to 50 feet wide at the top, and 25 feet tall. Any creature or object in the water and within 25 feet of the vortex is pulled 10 feet toward it. A creature can swim away from the vortex by making a Strength (Athletics) check against your spell save DC.',
      "When a creature enters the vortex for the first time on a turn or starts its turn there, it must make a strength saving throw. On a failed save, the creature takes 2d8 bludgeoning damage and is caught in the vortex until the spell ends. On a successful save, the creature takes half damage, and isn't caught in the vortex. A creature caught in the vortex can use its action to try to swim away from the vortex as described above, but has disadvantage on the Strength (Athletics) check to do so.",
      'The first time each turn that an object enters the vortex, the object takes 2d8 bludgeoning damage; this damage occurs each round it remains in the vortex.',
    ],
    range: '300 feet',
    components: ['V', 'S', 'M'],
    material: 'A drop of water and a pinch of dust.',
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'divination',
    name: 'Divination',
    url: '/api/spells/divination',
    shortdesc: 'Talk with a god',
    desc: [
      "Your magic and an offering put you in contact with a god or a god's servants. You ask a single question concerning a specific goal, event, or activity to occur within 7 days. The DM offers a truthful reply. The reply might be a short phrase, a cryptic rhyme, or an omen.",
      "The spell doesn't take into account any possible circumstances that might change the outcome, such as the casting of additional spells or the loss or gain of a companion.",
      'If you cast the spell two or more times before finishing your next long rest, there is a cumulative 25 percent chance for each casting after the first that you get a random reading. The DM makes this roll in secret.',
    ],
    range: 'Self',
    components: ['V', 'S', 'M'],
    material:
      'Incense and a sacrificial offering appropriate to your religion, together worth at least 25gp, which the spell consumes.',
    ritual: true,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'dominate-beast',
    name: 'Dominate Beast',
    url: '/api/spells/dominate-beast',
    shortdesc: 'Controls an animal telepathically',
    desc: [
      'You attempt to beguile a creature that you can see within range. It must succeed on a wisdom saving throw or be charmed by you for the duration. If you or creatures that are friendly to you are fighting it, it has advantage on the saving throw.',
      'While the creature is charmed, you have a telepathic link with it as long as the two of you are on the same plane of existence. You can use this telepathic link to issue commands to the creature while you are conscious (no action required), which it does its best to obey. You can specify a simple and general course of action, such as "Attack that creature," "Run over there," or "Fetch that object." If the creature completes the order and doesn\'t receive further direction from you, it defends and preserves itself to the best of its ability.',
      "You can use your action to take total and precise control of the target. Until the end of your next turn, the creature takes only the actions you choose, and doesn't do anything that you don't allow it to do. During this time, you can also cause the creature to use a reaction, but this requires you to use your own reaction as well. Each time the target takes damage, it makes a new wisdom saving throw against the spell. If the saving throw succeeds, the spell ends.",
    ],
    higher_level: [
      'When you cast this spell with a 9th level spell slot, the duration is concentration, up to 8 hours.',
    ],
    range: '60 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 4,
    dc: {
      dc_type: {
        index: 'wis',
        name: 'WIS',
        url: '/api/ability-scores/wis',
      },
      dc_success: 'none',
    },
  },
  {
    index: 'freedom-of-movement',
    name: 'Freedom of Movement',
    url: '/api/spells/freedom-of-movement',
    shortdesc:
      'For an hour, a target’s movement is unaffected by difficult terrain.',
    desc: [
      "You touch a willing creature. For the duration, the target's movement is unaffected by difficult terrain, and spells and other magical effects can neither reduce the target's speed nor cause the target to be paralyzed or restrained.",
      "The target can also spend 5 feet of movement to automatically escape from nonmagical restraints, such as manacles or a creature that has it grappled. Finally, being underwater imposes no penalties on the target's movement or attacks.",
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material: 'A leather strap, bound around the arm or a similar appendage.',
    ritual: false,
    duration: '1 hour',
    concentration: false,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'giant-insect',
    name: 'Giant Insect',
    url: '/api/spells/giant-insect',
    shortdesc: 'You transform into insects. Choose one.',
    desc: [
      'You transform up to ten centipedes, three spiders, five wasps, or one scorpion within range into giant versions of their natural forms for the duration. A centipede becomes a giant centipede, a spider becomes a giant spider, a wasp becomes a giant wasp, and a scorpion becomes a giant scorpion.',
      'Each creature obeys your verbal commands, and in combat, they act on your turn each round. The DM has the statistics for these creatures and resolves their actions and movement.',
      'A creature remains in its giant size for the duration, until it drops to 0 hit points, or until you use an action to dismiss the effect on it.',
      'The DM might allow you to choose different targets. For example, if you transform a bee, its giant version might have the same statistics as a giant wasp.',
    ],
    range: '30 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'hallucinatory-terrain',
    name: 'Hallucinatory Terrain',
    url: '/api/spells/hallucinatory-terrain',
    shortdesc:
      'You make natural terrain look and sound like some other sort of natural terrain.',
    desc: [
      "You make natural terrain in a 150-foot cube in range look, sound, and smell like some other sort of natural terrain. Thus, open fields or a road can be made to resemble a swamp, hill, crevasse, or some other difficult or impassable terrain. A pond can be made to seem like a grassy meadow, a precipice like a gentle slope, or a rock-strewn gully like a wide and smooth road. Manufactured structures, equipment, and creatures within the area aren't changed in appearance.",
      "The tactile characteristics of the terrain are unchanged, so creatures entering the area are likely to see through the illusion. If the difference isn't obvious by touch, a creature carefully examining the illusion can attempt an Intelligence (Investigation) check against your spell save DC to disbelieve it. A creature who discerns the illusion for what it is, sees it as a vague image superimposed on the terrain.",
    ],
    range: '300 feet',
    components: ['V', 'S', 'M'],
    material: 'A stone, a twig, and a bit of green plant.',
    ritual: false,
    duration: '24 hours',
    concentration: false,
    casting_time: '10 minutes',
    level: 4,
    area_of_effect: {
      type: 'cube',
      size: 150,
    },
  },
  {
    index: 'ice-storm',
    name: 'Ice Storm',
    url: '/api/spells/ice-storm',
    shortdesc:
      'Hail deals 4d6 cold and 2d8 bludgeoning damage in a cylinder 40 ft. across.',
    desc: [
      'A hail of rock-hard ice pounds to the ground in a 20-foot-radius, 40-foot-high cylinder centered on a point within range. Each creature in the cylinder must make a dexterity saving throw. A creature takes 2d8 bludgeoning damage and 4d6 cold damage on a failed save, or half as much damage on a successful one.',
      "Hailstones turn the storm's area of effect into difficult terrain until the end of your next turn.",
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 5th level or higher, the bludgeoning damage increases by 1d8 for each slot level above 4th.',
    ],
    range: '300 feet',
    components: ['V', 'S', 'M'],
    material: 'A pinch of dust and a few drops of water.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 4,
    damage: {
      damage_type: {
        index: 'bludgeoning',
        name: 'Bludgeoning',
        url: '/api/damage-types/bludgeoning',
      },
      damage_at_slot_level: {
        lvl4: '2d8 + 4d6',
        lvl5: '3d8 + 4d6',
        lvl6: '4d8 + 4d6',
        lvl7: '5d8 + 4d6',
        lvl8: '6d8 + 4d6',
        lvl9: '7d8 + 4d6',
      },
    },
    dc: {
      dc_type: {
        index: 'dex',
        name: 'DEX',
        url: '/api/ability-scores/dex',
      },
      dc_success: 'half',
    },
    area_of_effect: {
      type: 'cylinder',
      size: 20,
    },
  },
  {
    index: 'locate-creature',
    name: 'Locate Creature',
    url: '/api/spells/locate-creature',
    shortdesc:
      'Describe or name a creature. You sense the direction to the creature’s location',
    desc: [
      "Describe or name a creature that is familiar to you. You sense the direction to the creature's location, as long as that creature is within 1,000 feet of you. If the creature is moving, you know the direction of its movement.",
      "The spell can locate a specific creature known to you, or the nearest creature of a specific kind (such as a human or a unicorn), so long as you have seen such a creature up close--within 30 feet--at least once. If the creature you described or named is in a different form, such as being under the effects of a polymorph spell, this spell doesn't locate the creature.",
      "This spell can't locate a creature if running water at least 10 feet wide blocks a direct path between you and the creature.",
    ],
    range: 'Self',
    components: ['V', 'S', 'M'],
    material: 'A bit of fur from a bloodhound.',
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'polymorph',
    name: 'Polymorph',
    url: '/api/spells/polymorph',
    shortdesc:
      'This spell transforms a creature that you can see within range into a new form',
    desc: [
      'This spell transforms a creature that you can see within range into a new form. An unwilling creature must make a wisdom saving throw to avoid the effect. A shapechanger automatically succeeds on this saving throw.',
      "The transformation lasts for the duration, or until the target drops to 0 hit points or dies. The new form can be any beast whose challenge rating is equal to or less than the target's (or the target's level, if it doesn't have a challenge rating). The target's game statistics, including mental ability scores, are replaced by the statistics of the chosen beast. It retains its alignment and personality.",
      "The target assumes the hit points of its new form. When it reverts to its normal form, the creature returns to the number of hit points it had before it transformed. If it reverts as a result of dropping to 0 hit points, any excess damage carries over to its normal form. As long as the excess damage doesn't reduce the creature's normal form to 0 hit points, it isn't knocked unconscious.",
      "The creature is limited in the actions it can perform by the nature of its new form, and it can't speak, cast spells, or take any other action that requires hands or speech.",
      "The target's gear melds into the new form. The creature can't activate, use, wield, or otherwise benefit from any of its equipment.",
    ],
    range: '60 feet',
    components: ['V', 'S', 'M'],
    material: 'A caterpillar cocoon.',
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 4,
    dc: {
      dc_type: {
        index: 'wis',
        name: 'WIS',
        url: '/api/ability-scores/wis',
      },
      dc_success: 'none',
    },
  },
  {
    index: 'stone-shape',
    name: 'Stone Shape',
    url: '/api/spells/stone-shape',
    shortdesc:
      'ou touch a stone object  and form it into any shape that suits your purpose.',
    desc: [
      "You touch a stone object of Medium size or smaller or a section of stone no more than 5 feet in any dimension and form it into any shape that suits your purpose. So, for example, you could shape a large rock into a weapon, idol, or coffer, or make a small passage through a wall, as long as the wall is less than 5 feet thick. You could also shape a stone door or its frame to seal the door shut. The object you create can have up to two hinges and a latch, but finer mechanical detail isn't possible.",
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material:
      'Soft clay, to be crudely worked into the desired shape for the stone object.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'stoneskin',
    name: 'Stoneskin',
    url: '/api/spells/stoneskin',
    shortdesc:
      'Target gains resistance to nonmagical bludgeoning, piercing, and slashing damage.',
    desc: [
      'This spell turns the flesh of a willing creature you touch as hard as stone. Until the spell ends, the target has resistance to nonmagical bludgeoning, piercing, and slashing damage.',
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material: 'Diamond dust worth 100 gp, which the spell consumes.',
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 4,
  },
  {
    index: 'wall-of-fire',
    name: 'Wall of Fire',
    url: '/api/spells/wall-of-fire',
    shortdesc:
      'You can make a fire wall up to 60 feet long, 20 feet high, and 1 foot thick',
    desc: [
      'You create a wall of fire on a solid surface within range. You can make the wall up to 60 feet long, 20 feet high, and 1 foot thick, or a ringed wall up to 20 feet in diameter, 20 feet high, and 1 foot thick. The wall is opaque and lasts for the duration.',
      'When the wall appears, each creature within its area must make a Dexterity saving throw. On a failed save, a creature takes 5d8 fire damage, or half as much damage on a successful save.',
      'One side of the wall, selected by you when you cast this spell, deals 5d8 fire damage to each creature that ends its turn within 10 feet o f that side or inside the wall. A creature takes the same damage when it enters the wall for the first time on a turn or ends its turn there. The other side o f the wall deals no damage.',
      'The other side of the wall deals no damage.',
    ],
    higher_level: [
      'When you cast this spell using a level spell slot 5 or more, the damage of the spell increases by 1d8 for each level of higher spell slot to 4.',
    ],
    range: '120 feet',
    components: ['V', 'S', 'M'],
    material: 'A small piece of phosphorus.',
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 4,
    damage: {
      damage_type: {
        index: 'fire',
        name: 'Fire',
        url: '/api/damage-types/fire',
      },
      damage_at_slot_level: {
        4: '5d8',
      },
    },
    dc: {
      dc_type: {
        index: 'dex',
        name: 'DEX',
        url: '/api/ability-scores/dex',
      },
      dc_success: 'half',
    },
    area_of_effect: {
      type: 'line',
      size: 60,
    },
  },
];

export default spellsLVL4;
